import styled from 'styled-components/macro';
import { space } from '../../../theme/tokens';
import * as StaffCommon from '../../common/elements/Staff';
import * as Topics from './Topics';

export const StaffRowFill = styled(StaffCommon.StaffRow)`
  flex-grow: 1;
`;

export const ModuleList = styled(Topics.CardList)``;

export const Module = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  width: 100%;
  min-width: 0;
`;

export const ProgressContainer = styled.div`
  width: 100%;
  max-width: 32rem;
  padding: ${space[4]} 0 ${space[2]};
`;

export * from '../../common/elements/Notifications';
export * from './Topics';
